import { isNil } from 'lodash';
import { Component, useCallback } from 'react';
import { useToast } from '@shared/components/toast';
import { MBActionSheet } from '@shared/util/actionSheet';
import { i18n } from '@shared/util/i18n';
import { useRemoveCard } from '../hooks';

export function useRemoveCardWithConfirmation(card: MBAPI.Card, onRemoved?: () => void) {
  const removeCard = useRemoveCard();
  const toast = useToast();

  return useCallback(
    (anchor: Component) => {
      async function remove(scope: MBAPI.EntityRecurrenceScope) {
        await removeCard(card.id, scope);
        onRemoved?.();
        toast?.show({
          icon: 'check-filled',
          message: i18n('card.details.deleteCompleted', { card: card.fields?.name }),
        });
      }

      if (!isNil(card.recurrence)) {
        MBActionSheet.show({
          parent: anchor,
          title: i18n('card.details.deleteScopeActionSheet.title'),
          webHorizontalAlignment: 'right',
          options: [
            {
              title: i18n('card.details.deleteScopeActionSheet.currentOnly'),
              onPress: () => void remove('ENTITY'),
            },
            {
              title: i18n('card.details.deleteScopeActionSheet.currentAndUpcoming'),
              onPress: () => void remove('ENTITY_UPCOMING'),
            },
          ],
        });
      } else {
        MBActionSheet.show({
          parent: anchor,
          title: i18n('card.details.deleteConfirmation.title'),
          webHorizontalAlignment: 'right',
          options: [
            {
              title: i18n('card.details.deleteConfirmation.confirm'),
              destructive: true,
              onPress: () => void remove('ENTITY'),
            },
            {
              title: i18n('common.cancel'),
            },
          ],
        });
      }
    },
    [removeCard, onRemoved, card, toast],
  );
}
